const Nominal = `
  id
  description
  active
  label
  updatedAt
`;

export default Nominal;
